/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EnableAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function EnableAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/Keys/Content/ChangeStatus/Content/EnableAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let tabSelectedDevelopersStatusValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.developers.status',
format: fromHelpers.getStatusText,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="tab.selected.developers.status"
 format="helpers.js getStatusText"
 text={tabSelectedDevelopersStatusValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}